import Chip from '@mui/material/Chip';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import InventoryIcon from '@mui/icons-material/Inventory';
import TuneIcon from '@mui/icons-material/Tune';

import { useReferencesContext } from '../../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import type { EnrichedSection } from '../../types/enriched-section.type';

interface Props {
  readonly section: EnrichedSection;
}

export const ContentOrigin = ({ section }: Readonly<Props>) => {
  const { contentOriginsCodeMap } = useReferencesContext();

  const contentOriginId =
    section.insertionPoint?.contentOriginId ?? section.contentOriginId;

  switch (contentOriginId) {
    case contentOriginsCodeMap.Special._id: {
      return (
        <Chip
          color="info"
          icon={<NewReleasesIcon />}
          label="Spécial"
          sx={{ opacity: 0.5 }}
        />
      );
    }
    case contentOriginsCodeMap.Catalog._id: {
      return (
        <Chip
          color="success"
          icon={<InventoryIcon />}
          label="Référentiel"
          sx={{ opacity: 0.5 }}
        />
      );
    }
    case contentOriginsCodeMap.Modified._id: {
      return (
        <Chip
          color="primary"
          icon={<TuneIcon />}
          label="Modifié"
          sx={{ opacity: 0.5 }}
        />
      );
    }
    default:
      throw new Error(`Unknown content origin id: ${contentOriginId}`);
  }
};
